<div class="input-wrapper">
  <ion-item mode="ios" (click)="showSelect(vehicle_types, 'Vehicle Type')">
    <ion-label *ngIf="showHeading" position="{{ labelPosition }}">Vehicle Type</ion-label>
    <ion-input readonly="true" [disabled]="readOnly" [(ngModel)]="vehicleTypeUnderwriting.object_answer"></ion-input>
  </ion-item>
  <ion-item mode="ios" (click)="showSelect(listYear, 'Year of Registration')">
    <ion-label *ngIf="showHeading" position="{{ labelPosition }}">Year of registration</ion-label>
    <ion-input readonly="true" [disabled]="readOnly || !vehicleTypeUnderwriting.object_answer" [(ngModel)]="yearRegUnderwriting.object_answer"></ion-input>
  </ion-item>
  <ion-item mode="ios" (click)="showSelect(listYear, 'Year of Manufacture')">
    <ion-label *ngIf="showHeading" position="{{ labelPosition }}">Year of manufacture</ion-label>
    <ion-input readonly="true" [disabled]="!makes || readOnly || !yearRegUnderwriting.object_answer" [(ngModel)]="yearUnderwriting.object_answer"></ion-input>
  </ion-item>
  <p class="error-message" *ngIf="error">{{ error }}</p>
  <ion-item mode="ios" (click)="selectMakePopup()">
    <ion-label *ngIf="showHeading" position="{{ labelPosition }}">Make</ion-label>
    <ion-input [disabled]="!makes || readOnly || !yearUnderwriting.object_answer" readonly="true" [(ngModel)]="makeUnderwriting.object_answer"></ion-input>
  </ion-item>
  <p class="error-message" *ngIf="error">{{ error }}</p>
  <ion-item mode="ios" (click)="showSelect(models, 'Model')">
    <ion-label *ngIf="showHeading" position="{{ labelPosition }}">Model</ion-label>
    <ion-input readonly="true" [disabled]="!models || readOnly" [(ngModel)]="modelUnderwriting.object_answer"></ion-input>
  </ion-item>
  <p class="error-message" *ngIf="error">{{ error }}</p>
</div>

<div class="short-backdrop" *ngIf="showSelectPopup"></div>
<div class="select-popup limit-width-on-desktop-float" *ngIf="showSelectPopup">
  <div class="heading">
    <h2 class="h2-bold">{{ popupHeading }}</h2>
  </div>
  <div class="select-wrapper" *ngIf="popupHeading === 'Make'">
    <input #searchInputMakes type="text" class="input-search" placeholder="Search vehicle makes" (keyup)="search($event, 'make')"/>
    @if (searchFound && searchFound.length > 0) {
      <ion-item
        mode="md"
        *ngFor="let selectOption of searchFound"
        lines="none"
        [ngClass]="{ active: selectOption == selectAnswer }"
        (click)="setAnswer(selectOption)"
      >
        <ion-text>{{ selectOption.description }}</ion-text>
      </ion-item>
    } @else {
      <ion-item
        mode="md"
        *ngFor="let selectOption of makes"
        lines="none"
        [ngClass]="{ active: selectOption == selectAnswer }"
        (click)="setAnswer(selectOption)"
      >
        <ion-text>{{ selectOption.description }}</ion-text>
      </ion-item>
    }
  </div>

  <div class="select-wrapper" *ngIf="popupHeading === 'Vehicle Type'">
    <ion-item
      mode="md"
      *ngFor="let selectOption of selectArray"
      lines="none"
      [ngClass]="{ active: selectOption.description == selectAnswer }"
      (click)="setAnswer(selectOption)"
    >
      <ion-text>{{ selectOption.description }}</ion-text>
    </ion-item>
  </div>

  <div class="select-wrapper" *ngIf="popupHeading === 'Year of Manufacture' || popupHeading === 'Year of Registration'">
    <ion-item
      mode="md"
      *ngFor="let selectOption of selectArray"
      lines="none"
      [ngClass]="{ active: selectOption == selectAnswer }"
      (click)="setAnswer(selectOption)"
    >
      <ion-text>{{ selectOption }}</ion-text>
    </ion-item>
  </div>

  <div class="select-wrapper" *ngIf="popupHeading === 'Model'">
    <input #searchInputModels type="text" class="input-search" placeholder="Search vehicle models" (keyup)="search($event, 'model')"/>
    @if (searchFound && searchFound.length > 0) {
      <ion-item
        mode="md"
        *ngFor="let selectOption of searchFound"
        lines="none"
        [ngClass]="{ active: selectOption.description == selectAnswer }"
        (click)="setAnswer(selectOption)"
      >
        <ion-text>{{ selectOption.description }}</ion-text>
      </ion-item>
    } @else {
      <ion-item
        mode="md"
        *ngFor="let selectOption of selectArray"
        lines="none"
        [ngClass]="{ active: selectOption.description == selectAnswer }"
        (click)="setAnswer(selectOption)"
      >
        <ion-text>{{ selectOption.description }}</ion-text>
      </ion-item>
    }
    
  </div>
  <div class="buttons-wrapper">
    <ion-button mode="ios" (click)="closeSelectPopup()" class="secondary-button">Cancel</ion-button>
  </div>
</div>
